export default __webpack_public_path__ + "static/064-75396d245cdc35fd64ed74d2080c37d8.jpg";